import Select from "react-select";
import PropTypes from "prop-types";

export const InputSelect = props => {
  const {
    arr = [],
    id,
    formik,
    label = "xxx",
    llave_texto = "nombre",
    llave_valor = "id",
    ejecute,
    disabled = false,
    clases = "",
    subKey = "",
    placeholder = "---Seleccione---",
    labelStyle,
    labelClassName,
    menuPlacement = "auto",
  } = props;

  const arrOpts = (t, texto, valor) => (t || []).map(el => ({ label: el[texto], value: valor ? el[valor] : el }));
  const options = arrOpts(arr, llave_texto, llave_valor);

  const getSelectValue = () => {
    if (!formik || formik.values[id] === undefined || formik.values[id] === null || formik.values[id] === "") {
      return null;
    }
    const current = formik.values[id];
    if (typeof current === "object" && current !== null) {
      return (
        options.find(opt => {
          if (!opt.value) return false;
          if (opt.value === current) return true;
          if (opt.value.id && current.id && String(opt.value.id) === String(current.id)) return true;
          if (opt.value.NOMBRE_UO && current.NOMBRE_UO && opt.value.NOMBRE_UO === current.NOMBRE_UO) return true;
          return JSON.stringify(opt.value) === JSON.stringify(current);
        }) || null
      );
    }
    const strCurrent = String(current).trim();
    const pipeParts = strCurrent.includes("|") ? strCurrent.split("|").map(p => p.trim()) : null;

    return (
      options.find(opt => {
        if (opt.value === current) return true;
        if (typeof opt.value === "string" && String(opt.value).trim() === strCurrent) return true;
        if (opt.label && String(opt.label).trim() === strCurrent) return true;

        if (pipeParts) {
          const [codePart, namePart] = pipeParts;
          if (opt.value !== undefined && opt.value !== null && String(opt.value).trim() === codePart) return true;
          if (opt.label && String(opt.label).trim() === namePart) return true;
          if (codePart && namePart && opt.label && String(opt.label).trim() === `${codePart} - ${namePart}`) return true;
        }

        if (typeof opt.value === "string" && opt.value.includes("|")) {
          const [optCode, optName] = opt.value.split("|").map(p => p.trim());
          if (strCurrent === optCode || strCurrent === optName) return true;
        }

        if (typeof opt.value === "object" && opt.value !== null) {
          if (opt.value.NOMBRE_UO && String(opt.value.NOMBRE_UO).trim() === strCurrent) return true;
          if (opt.value.nombre && String(opt.value.nombre).trim() === strCurrent) return true;
          if (opt.value.id && String(opt.value.id).trim() === strCurrent) return true;
          if (pipeParts) {
            if (opt.value.id && String(opt.value.id).trim() === pipeParts[0]) return true;
            if (opt.value.Planhorariocodigoerp && String(opt.value.Planhorariocodigoerp).trim() === pipeParts[0]) return true;
            if (opt.value.Planhorarionombre && String(opt.value.Planhorarionombre).trim() === pipeParts[1]) return true;
          }
        }
        return false;
      }) || null
    );
  };

  const formatLabel = (txt) => {
    if (typeof txt !== "string") return txt;
    if (txt.includes("*")) {
      const parts = txt.split("*");
      return (
        <>
          {parts[0]} <span className="text-danger fw-bold">*</span>
          {parts.slice(1).join("*")}
        </>
      );
    }
    return txt;
  };

  return (
    <>
      {Boolean(label) && label !== "xxx" && (
        <label
          htmlFor={id}
          className={labelClassName || "form-label fw-bold mb-1"}
          style={labelStyle}
        >
          {formatLabel(label)}
        </label>
      )}
      <Select
        key={subKey}
        isDisabled={disabled}
        texto=""
        name={id}
        id={id}
        className={`selectDos ${clases}`}
        value={formik ? getSelectValue() : undefined}
        onChange={e => {
          formik ? formik.setValues({ ...formik.values, [id]: e ? e.value : "" }) : ejecute(e);
        }}
        placeholder={placeholder}
        isClearable={true}
        menuPlacement={menuPlacement}
        menuPosition="fixed"
        maxMenuHeight={220}
        classNamePrefix={"limpiarSelect"}
        options={options}
        menuPortalTarget={typeof document !== "undefined" ? document.body : null}
        styles={{
          menuPortal: base => ({ ...base, zIndex: 9999 }),
          menu: base => ({ ...base, zIndex: 9999 }),
        }}
      />
    </>
  );
};

InputSelect.propTypes = {
  arr: PropTypes.array,
  id: PropTypes.string,
  formik: PropTypes.object,
  label: PropTypes.string,
  llave_texto: PropTypes.string,
  llave_valor: PropTypes.string,
  ejecute: PropTypes.func,
  disabled: PropTypes.bool,
  clases: PropTypes.string,
  subKey: PropTypes.string,
  placeholder: PropTypes.string,
  labelStyle: PropTypes.object,
  labelClassName: PropTypes.string,
  menuPlacement: PropTypes.string,
};
